







import Component from "vue-class-component";

import { BaseRootPageComponent } from "../BaseRootPageComponent";
import { EventBus, EventNames } from "@/utils/eventBus";
import _gateway from "@/utils/gateway";
import { updateGTMGlobalVariables } from "@/utils/gtm";

export const ErrorConnectionLost =
  "The connection has been lost. Please check your device settings.<br /><br />You will not receive notifications or updates until the connection is restored.";

@Component
export default class ConnectionError extends BaseRootPageComponent {
  gateway = _gateway;

  error = ErrorConnectionLost;

  isDestroyed = false;

  created() {
    this.setTitle("Connection Error");
    // updateGTMGlobalVariables(this);

    this.subscribeToEvents();

    // Immediately try to see if the user is connected when the page opens
    this.tryAgain();
  }

  subscribeToEvents() {
    // If the component has already been destroyed (e.g. the user navigated away while the initial data was being
    // loaded), don't register for the data refresh event otherwise, it will never be removed and will keep running
    // until the user reloads the webpage.
    if (this.isDestroyed) return;

    EventBus.$on(EventNames.DataRefresh, this.tryAgain);
  }

  beforeDestroy() {
    EventBus.$off(EventNames.DataRefresh, this.tryAgain);
    this.isDestroyed = true;
  }

  async tryAgain() {
    // If somehow the component was already destroyed, don't bother pinging
    if (this.isDestroyed) return;

    try {
      await this.gateway.pingConnection();
      // If the the server can be accessed, go back to the previous page
      this.$router.go(-1);
    } catch (error) {
      // If the server isn't reachable, just stay on the page
      console.error("Ping to server failed", error);
    }
  }
}
